// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"faqs_wrapper__8TMtr","container":"faqs_container___Ubmd","faq_tab_upd-Wrapperr":"faqs_faq_tab_upd-Wrapperr__xvypo"};